import { render } from "./MarcasAdminView.vue?vue&type=template&id=5db1595b&ts=true"
import script from "./MarcasAdminView.vue?vue&type=script&lang=ts"
export * from "./MarcasAdminView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/frontend-marketbo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__